import { IParameterizable } from './page-service/parameterizable.model';
import { IQueryParams } from './page-service/query-params.model';

export class Query implements IParameterizable {
    constructor(public query: string) {}

    generateParams(): IQueryParams {
        const pageParams: IQueryParams = {
            queryString: 'query',
            params: this.query ? [{ value: `${this.query}` }] : [],
        };

        return pageParams;
    }
}
